<div class="ag-filter-toolpanel-instance-body ag-filter" ref="agFilterToolPanelBody">
  <div class="ag-filter-toolpanel-instance-filter">
    <div class="ag-filter-wrapper ag-focus-managed">
      <div class="ag-filter-body-wrapper ag-set-filter-body-wrapper">
        <div class="ag-set-filter">
          <div ref="eFilterLoading" class="ag-filter-loading ag-hidden">Loading...</div>
          <!--AG-INPUT-TEXT-FIELD-->
          <div
            role="presentation"
            class="ag-mini-filter ag-labeled ag-label-align-left ag-text-field ag-input-field ag-hidden"
            ref="eMiniFilter"
          >
            <div
              ref="eLabel"
              class="ag-input-field-label ag-label ag-hidden ag-text-field-label"
              role="presentation"
            ></div>
            <div
              ref="eWrapper"
              class="ag-wrapper ag-input-wrapper ag-text-field-input-wrapper"
              role="presentation"
            >
              <input
                ref="eInput"
                class="ag-input-field-input ag-text-field-input"
                type="text"
                id="ag-1134-input"
                aria-label="Search filter values"
                placeholder="Search..."
              />
            </div>
          </div>
          <div ref="eFilterNoMatches" class="ag-filter-no-matches ag-hidden">No matches.</div>
            <div role="presentation" class="skytank-filter-options">
              <div class="ag-tab-guard ag-tab-guard-top" role="presentation" tabindex="0"></div>
              <div
                *ngIf="formGroup"
                fxLayout="column"
                [formGroup]="formGroup"
              >
                <div class="filter-content">
                  <div fxLayout="row" fxLayoutAlign="start center" class="filter-row">
                    <mat-checkbox formControlName="allSkytankGateways" class="unpaired-checkbox">
                      <span class="checkbox-label">{{
                        'Column.Filter.allSkytankGateways' | translate
                      }}</span>
                    </mat-checkbox>
                  </div>
                </div>
              </div>
              <div class="ag-tab-guard ag-tab-guard-bottom" role="presentation" tabindex="1"></div>
            </div>
        </div>
      </div>
      <div class="ag-filter-apply-panel">
        <button
          type="button"
          ref="resetFilterButton"
          class="ag-standard-button ag-filter-apply-panel-button"
                    [disabled]="disableReset()"
                    (click)="clearFilter()"
        >{{ 'General.Reset' | translate }}</button
        ><button
          type="button"
          ref="applyFilterButton"
          class="ag-standard-button ag-filter-apply-panel-button"
          [disabled]="disableApply()"
          (click)="applyFilterValue()"
        >
          {{ 'General.Apply' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>